<template>
  <div class="is-flex is-justify-content-center is-align-items-center">

    <div v-if="isSubmitted" class="is-flex container is-align-items-center is-justify-content-space-evenly">
      <button @click="handleWhatsApp('green')" class="button is-info">Green Statuses</button>
      <button @click="handleWhatsApp('reject')" class="button is-info">Company Rejected Statuses</button>
    </div>

    <div v-else class="is-flex container is-align-items-center">
      <button @click="hanleSubmit" class="button is-info mx-5">Submit</button>
      <input v-model="cellPhone" class="input ltr" type="text" placeholder="cell phone"/>
    </div>

  </div>
</template>

<script>
import { getWhatsAppLinkRecipe } from '@/custom/classes/my_utils.js'
import OffersHelper from '@/custom/classes/offers_helper.js'

export default {
  name: 'ModalCompanyWhatsApp',
  props: {
    CompanyId: {
      type: [String, Number]
    },
    PositionId: {
      type: [String, Number]
    },
    PositionName: {
      type: [String, Number]
    }
  },
  data () {
    return {
      cellPhone: '',
      isSubmitted: false,
      statuses: {
        green: ['awaiting_company_sent', 'company_process', 'interview'],
        reject: ['company_rejected']
      },
      translator: {
        awaiting_company_sent: ' \n*מועמדים שממתינים לתגובה:*\n ',
        company_process: ' \n*מועמדים שהתעניינתם בהם:*\n ',
        interview: ' \n*מועמדים שראיינתם:*\n ',
        company_rejected: ''
      }
    }
  },
  computed: {
    sendCellPhone () {
      if (this.cellPhone.startsWith('+972') && this.cellPhone.length == 13) {
        return this.cellPhone
      }
      if (this.cellPhone.startsWith('972') && this.cellPhone.length == 12) {
        return `+972${this.cellPhone.substring(3)}`
      }
      if (this.cellPhone.startsWith('05') && (this.cellPhone.length >= 10 && this.cellPhone.length <= 12)) {
        return `+972${this.cellPhone.substring(1)}`
      }
      return undefined
    }
  },
  async created () {
    const company = await this.$network_utils.getCompany({ id: this.CompanyId })
    this.cellPhone = company.whatsapp_number
  },
  methods: {
    async hanleSubmit () {
      if (!this.cellPhone) {
        return
      }
      await this.$network_utils.updateCompany({ id: this.CompanyId, whatsapp_number: this.sendCellPhone })
      this.isSubmitted = true
    },
    getStatuses (btn) {
      return this.statuses[btn] || this.statuses.red
    },
    async handleWhatsApp (btn) {
      const statuses = this.getStatuses(btn).join(',')
      const response = await this.$network_utils.getResourceOffers({
        company_id: this.CompanyId,
        resource_type: 'Position',
        resource_id: this.PositionId,
        statuses
      })
      const data = this.formatApplicantData(response)
      const applicants = Object.keys(data).reduce((prev, key) => {
        return prev + this.translator[key] + data[key]
      }, '')
      const position = this.PositionName
      const template = btn === 'green' ? 'greenCompanyMessage' : 'rejectCompanyMessage'
      const text = (new OffersHelper()).outSourceTemplate({ applicants, position }, template)
      const url = getWhatsAppLinkRecipe({ phone_number: this.sendCellPhone, text: text })
      window.open(url, '_blank', 'noreferrer')
    },
    formatApplicantData (offers) {
      return offers.reduce((prev, offer) => {
        const { full_name: fullname } = offer.applicant
        const { name: status } = offer.status
        prev[status] = prev[status] ? prev[status] + '\n' + fullname : fullname
        return prev
      }, {})
    }
  }
}
</script>

<style>
  .container {
    min-height: 200px;
  }
</style>
